<script lang="ts">
  import { createEventDispatcher } from "svelte"
  import classnames from "classnames"
  import { omit } from "$lib/utils/object"
  // Components
  import { Icon } from '$lib/components/atoms/Icon';

  // Default Props
  export let color: "dark" | "light" = "dark"
  export let iconPos: "start" | "end" = "end"
  export let size: "small" | "default" = "default"
  /** -- */
  export let icon: string = "heart"
  export let href = "#"
  export let disabled = false

  const dispatch = createEventDispatcher()

  const onClick = (e: Event) => {
    if (!href || href === "#") {
      e.preventDefault()
    }
    dispatch("click")
  }

  const classNames = classnames($$props.class, {
    link: true,
    "link-icon-end": iconPos === "end",
    "link-icon-start": iconPos === "start",
    "c-dark": color === "dark",
    "c-light": color === "light",
    "s-default": size === "default",
    "s-small": size === "small",
  })
  const attributes = omit($$restProps, "class")
</script>

<a href="{href}" class="{classNames}" class:disabled {...attributes} on:click="{onClick}">
  <span class="link-text">
    <slot />
  </span>
  <span class="link-icon">
    <Icon icon="{icon}" />
  </span>
</a>

<style type="text/scss" lang="scss" scoped>
  .link {
    @apply appearance-none;
    @apply inline-flex flex-shrink-0 items-center self-center;
    @apply uppercase font-semibold;
    @apply whitespace-nowrap no-underline tracking-wide;
    @apply border-none;
    @apply p-0;
    @apply select-none;
    @apply transition-colors ease-in-out duration-300;

    &:not(.disabled) {
      @apply cursor-pointer;
      @apply transition-colors ease-in-out duration-300;
    }

    &.disabled {
      @apply text-gray-900 text-opacity-50;
      @apply pointer-events-none;
      @apply cursor-default;
    }

    &:hover {
      .link-icon {
        @apply transform scale-105;
      }
    }
  }

  /* SIZES */
  .s-small {
    @apply text-sm;
  }

  .s-default {
    @apply text-sm md:text-base;
  }

  /* COLORS */
  .c-dark {
    @apply text-gray-900;
    /* Hover */
    @apply hover:text-petrol;
  }

  .c-light {
    @apply text-white;
  }

  /* ICON ALIGNMENT */

  .link-icon {
    @apply inline-flex;
    @apply transition-transform ease-in-out duration-300;
  }

  .link-icon-end {
    .link-text + .link-icon {
      @apply ml-2;
    }
  }

  .link-icon-start {
    @apply flex-row-reverse;

    .link-text + .link-icon {
      @apply mr-2;
    }
  }
</style>
